import { OverAllStory } from './OverAllStory'
import { withOverAllStory } from './withOverAllStory'

const ConnectedOverAllStory = withOverAllStory(OverAllStory)

export { ConnectedOverAllStory as OverAllStory }
